module.exports = __webpack_public_path__ + "img/Grimmig.aabb21e8.svg";